/* eslint max-classes-per-file: 0 */

import {
  FormTemplate as Data,
  FormTemplateCollection as Collection,
  FormTemplateCount,
} from '@/typings/api/FormTemplate'

import { Fabric } from '@/store/createCrudModule'
import { FormTemplatesAdapter } from './FormTemplatesAdapter'


export const fabric = Fabric<Data, Collection>()

type S = FormTemplateState
type G = FormTemplateGetters
type M = FormTemplateMutations
type A = FormTemplateActions


export class FormTemplateState extends fabric.State {
}

export class FormTemplateGetters extends fabric.Getters<S> {
}

export class FormTemplateMutations extends fabric.Mutations<S> {
}

export class FormTemplateActions extends fabric.Actions<S, G, M, A> {
    protected readonly adapter = new FormTemplatesAdapter();

    protected readonly idName = 'id';

    public copy(options: Data) {
      return this.adapter.api.copy(options.id)
    }

    public async count(options: Data) {
      if (options.id) {
        try {
          const { data } = await this.adapter.api.count<FormTemplateCount>(options.id)
          return data?.count || 0
        } catch (e) {
          return 0
        }
      }
      return 0
    }
}
